<template>
  <div class="pa-0 ma-0">
    <niko-toggle
      class="mt-0 mb-6"
      :value="test.include_ra_rugl_maintenance"
      :label="$t('room.illumination.toggle.ra_rugl_maintenance')"
      @onChange="
        (value) => {
          const options = {
            index,
            attribute: 'include_ra_rugl_maintenance',
            newValue: value,
          };
          changeIlluminationTestAttribute(options);
        }
      "
    />
    <v-subheader class="mb-1 ml-0 pl-0" style="height: auto">
      {{ $t("room.illumination.preconditions") }}
    </v-subheader>

    <niko-textarea
      :rows="1"
      :value="test.test_requirements"
      @onChange="
        (value) => {
          const options = {
            index,
            attribute: 'test_requirements',
            newValue: value,
          };
          changeIlluminationTestAttribute(options);
        }
      "
      :placeholder="$t('room.illumination.preconditions')"
    />

    <h4>{{ $t("room.illumination.illuminance.title") }}</h4>

    <niko-slider
      :label="$t('room.illumination.illuminance.required')"
      :min="0"
      :max="1500"
      suffix="lux"
      step="1"
      :value="test.average_illuminance"
      @onChange="
        (value) => {
          const options = {
            index,
            attribute: 'average_illuminance',
            newValue: value,
          };

          changeIlluminationTestAttribute(options);
        }
      "
    ></niko-slider>

    <niko-slider
      v-if="test.include_ra_rugl_maintenance"
      :label="$t('room.illumination.illuminance.maintenance_factor')"
      :min="0"
      :max="1"
      suffix="fm"
      step="0.05"
      :accuracy="0.01"
      :value="test.maintenance_factor"
      textFieldType="text"
      @onChange="
        (valueObj) => {
          const options = {
            index,
            attribute: 'maintenance_factor',
            newValue: valueObj.value,
          };

          changeIlluminationTestAttribute(options);
        }
      "
    />

    <niko-slider
      :label="$t('room.illumination.illuminance.deviation')"
      :subLabel="$t('room.illumination.illuminance.deviation_info')"
      :min="0"
      :max="100"
      suffix="%"
      step="1"
      :value="test.illuminance_deviation"
      @onChange="
        (value) => {
          const options = {
            index,
            attribute: 'illuminance_deviation',
            newValue: value,
          };
          changeIlluminationTestAttribute(options);
        }
      "
    ></niko-slider>

    <h4>{{ $t("room.illumination.uniformity.title") }}</h4>

    <niko-slider
      :label="$t('room.illumination.uniformity.required')"
      :min="0"
      :max="1"
      suffix="U0"
      step="0.05"
      :accuracy="0.01"
      :value="test.uniformity"
      textFieldType="text"
      @onChange="
        (valueObj) => {
          const options = {
            index,
            attribute: 'uniformity',
            newValue: valueObj.value,
          };
          changeIlluminationTestAttribute(options);
        }
      "
    ></niko-slider>

    <div v-if="test.include_ra_rugl_maintenance">
      <h4>{{ $t("room.illumination.ra.title") }}</h4>

      <niko-slider
        :label="$t('room.illumination.ra.required')"
        :min="0"
        :max="100"
        suffix="Ra"
        step="5"
        :value="test.required_ra"
        @onChange="
          (value) => {
            const attributes = ['required_ra', 'measured_ra'];
            attributes.forEach((attribute) => {
              const options = {
                index,
                attribute,
                newValue: value,
              };
              changeIlluminationTestAttribute(options);
            });
          }
        "
      />

      <h4>{{ $t("room.illumination.rugl.title") }}</h4>

      <niko-slider
        :label="$t('room.illumination.rugl.required')"
        :min="0"
        :max="40"
        step="1"
        :value="test.required_rugl"
        @onChange="
          (value) => {
            const attributes = ['required_rugl', 'measured_rugl'];
            attributes.forEach((attribute) => {
              const options = {
                index,
                attribute,
                newValue: value,
              };
              changeIlluminationTestAttribute(options);
            });
          }
        "
      />
    </div>

    <niko-toggle
      class="mt-4 mb-2"
      :value="test.include_flicker"
      :label="$t('room.illumination.toggle.flicker')"
      @onChange="
        (value) => {
          const options = {
            index,
            attribute: 'include_flicker',
            newValue: value,
          };
          changeIlluminationTestAttribute(options);
        }
      "
    />

    <div v-if="test.include_flicker">
      <niko-slider
        :label="$t('room.illumination.flicker.percentage')"
        :min="-1"
        :max="100"
        suffix="%"
        step="1"
        :value="test.required_flicker_percentage"
        @onChange="
          (value) => {
            const attributes = [
              'required_flicker_percentage',
              'measured_flicker_percentage',
            ];
            attributes.forEach((attribute) => {
              const options = {
                index,
                attribute,
                newValue: value,
              };
              changeIlluminationTestAttribute(options);
            });
          }
        "
      />
      <niko-slider
        :label="$t('room.illumination.flicker.index')"
        :min="-0.01"
        :max="1"
        step="0.01"
        :value="test.required_flicker_index"
        textFieldType="text"
        @onChange="
          (value) => {
            const attributes = [
              'required_flicker_index',
              'measured_flicker_index',
            ];
            attributes.forEach((attribute) => {
              const options = {
                index,
                attribute,
                newValue: value,
              };
              changeIlluminationTestAttribute(options);
            });
          }
        "
      />
    </div>

    <v-btn icon class="mb-6" @click="deleteIlluminationTest(index)">
      <v-icon>$iconDelete</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import NikoTextarea from "../UI/NikoTextarea";
import NikoSlider from "../UI/NikoSlider";
import NikoToggle from "../UI/NikoToggle";

export default {
  name: "illumination-test-details",
  components: { NikoSlider, NikoTextarea, NikoToggle },
  props: ["test", "index"],
  methods: {
    ...mapMutations("roomStore", [
      "changeIlluminationTestAttribute",
      "deleteIlluminationTest",
    ]),
  },
};
</script>
